import React from 'react';
import { Typography, Box, Card, CardContent } from '@mui/material';

export default function ProductTypeDetailsPage({ chartData, productTypeCategoryMap }) {
  // Build grouped pivot data
  const grouped = {};
  const allLexifiLinks = new Set();
  chartData.forEach(({ lexiFi_link, product_type_name, count }) => {
    allLexifiLinks.add(lexiFi_link);
    const category = productTypeCategoryMap[product_type_name] ? productTypeCategoryMap[product_type_name] : 'Other';
    if (!grouped[category]) grouped[category] = {};
    if (!grouped[category][product_type_name]) grouped[category][product_type_name] = {};
    grouped[category][product_type_name][lexiFi_link] = count;
  });
  const lexifiLinkArr = Array.from(allLexifiLinks);
  // Calculate total count for each group
  const groupEntries = Object.entries(grouped).map(([category, products]) => {
    const groupTotal = Object.values(products).reduce((sum, ptObj) => sum + Object.values(ptObj).reduce((s, v) => s + v, 0), 0);
    return { category, products, groupTotal };
  });
  // Sort groups by total count descending
  groupEntries.sort((a, b) => b.groupTotal - a.groupTotal);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Product Type Details</Typography>
      {groupEntries.map(({ category, products, groupTotal }) => {
        // Calculate totals by lexifi_link for this category
        const totals = {};
        lexifiLinkArr.forEach(link => {
          totals[link] = Object.keys(products).reduce((sum, pt) => sum + (products[pt][link] || 0), 0);
        });
        return (
          <Box key={category} sx={{ mb: 4 }}>
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              {category} ({groupTotal})
            </Typography>
            <table style={{ width: '100%', background: '#fafafa', marginBottom: 8 }}>
              <thead>
                <tr>
                  <th>Product Type</th>
                  {lexifiLinkArr.map(link => (
                    <th key={link}>{link}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.keys(products).map(pt => (
                  <tr key={pt}>
                    <td>{pt}</td>
                    {lexifiLinkArr.map(link => (
                      <td key={link}>{products[pt][link] || 0}</td>
                    ))}
                  </tr>
                ))}
                {/* Total row */}
                <tr style={{ fontWeight: 'bold', background: '#e0e0e0' }}>
                  <td>Total</td>
                  {lexifiLinkArr.map(link => (
                    <td key={link}>{totals[link]}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </Box>
        );
      })}
    </Box>
  );
}
